import React, { useState } from "react"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
  editedPagesState,
} from "../recoil-atom"

import { ItemTypes } from "./Constants.js"
import { useDrag, useDrop, DragSource, DragPreviewImage } from "react-dnd"

import LinkMarkEdit from "./LinkMarkEdit"

import { Mark, MarkIcon } from "../styled-components-openmark"
import styled, { css } from "styled-components"

const LinkMarkDrop = ({ pageId, groupId, markId, mark }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)
  const [editedPages, setEditedPages] = useRecoilState(editedPagesState)

  const [{ isOver, canDrop, getSource }, drop] = useDrop(
    () => ({
      accept: ItemTypes.MARK,
      drop: (item, monitor) => {
        const now = new Date()
        const newPagesObj = JSON.parse(JSON.stringify(updatedPagesObj))

        newPagesObj[item.pageId][item.groupId].splice(item.markId, 1)
        newPagesObj[item.pageId].updatedAt = now
        if (editedPages.includes(item.pageId) === false) {
          setEditedPages([...editedPages, item.pageId])
        }

        newPagesObj[pageId][groupId].splice(markId, 0, item.mark)
        newPagesObj[pageId][groupId].updatedAt = now
        if (editedPages.includes(pageId) === false) {
          setEditedPages([...editedPages, pageId])
        }

        setUpdatedPagesObj(JSON.parse(JSON.stringify(newPagesObj)))
      },
      canDrop: () => updatedPagesObj[pageId][groupId].length < 12,
      collect: (monitor) => ({
        // isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [pageId, groupId, markId, mark]
  )

  return (
    <>
      <Mark ref={drop}>
        <LinkMarkEdit
          pageId={pageId}
          groupId={groupId}
          markId={markId}
          mark={mark}
        />
      </Mark>
    </>
  )
}

export default LinkMarkDrop
